/**************************************************************************************************/
/*   File: /src/app/shared/enums/spatial.data.type.enum.ts                                        */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Tuesday February 19th 2019                                                     */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
/**
 * The spatial data type enum
 */
export enum SpatialDataTypeEnum {
    /**
     * The shape file type
     */
    SHAPE = 1,
    /**
     * The dwg file type
     */
    DWG = 2,
    /**
     * The dxf file type
     */
    DXF = 3
}